// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"13":"c9e0604d","485":"8039c0af","506":"48471255"}[chunkId] + ".chunk.js";
};